import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextLargeParagraphProps = Pick<
  TypographyProps,
  'label' | 'color' | 'uppercase' | 'ellipsis' | 'tagName'
>;

export const TextLargeParagraph = ({
  label,
  color = 'text-ds-natural',
  ellipsis,
  uppercase,
  tagName = 'p',
}: TextLargeParagraphProps) => (
  <Typography
    uppercase={uppercase}
    ellipsis={ellipsis}
    color={color}
    label={label}
    tagName={tagName}
    fontSize="text-ds-500"
    lineHeight="leading-ds-400"
    fontWeight="font-ds-normal"
  />
);
